export default __webpack_public_path__ + "static/media/viber_image_2022-06-04_14-35-08-841.3ea755b2.jpg";